<!-- 触顶/底预警 -->
<template>
    <div id="goodSearch" class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">仓库</div>
                <el-select v-model="searchData.WHId" :loading="loading" class="search-item" size="small" filterable remote>
                    <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index">
                        <span style="float: left">{{ optionItem.WarehouseName }}</span>
                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                    </el-option>
                </el-select>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询（Enter）</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
                <el-button size="small" class="search-btn" type="primary" @click="bacthUpdate()">批量设置</el-button>
            </div>
        </div>
        <div class="table-ctn goodlist-table">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border=""
                style="width: 100%"
                @selection-change="handleSelectionChange"
                @cell-dblclick="handleDBClick"
                @cell-click="showSaleData"
                @sort-change="sortChange"
                empty-text="暂无相关库存商品信息"
                v-loading="loading"
                ref="multipleTable"
            >
                <el-table-column type="selection" width="55" fixed="left"></el-table-column>
                <el-table-column show-overflow-tooltip prop="APCode" label="汽配编码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="GoodCode" label="互换码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="GoodName" label="汽配名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="AutoSerise" label="适用车型"></el-table-column>
                <el-table-column width="110" show-overflow-tooltip prop="Cate" label="汽配分类"></el-table-column>
                <el-table-column width="110" show-overflow-tooltip prop="Brand" label="品牌"></el-table-column>
                <el-table-column width="100" show-overflow-tooltip prop="Origin" label="产地"></el-table-column>
                <el-table-column width="80" show-overflow-tooltip prop="Inventory" label="总库存数"></el-table-column>
                <el-table-column width="100" show-overflow-tooltip prop="SpaceInvens">
                    <template slot="header">
                        <el-tooltip effect="dark" placement="top">
                            <div slot="content">商品存放在当前仓库下所有在仓总和</div>
                            <span>
                                <i class="el-icon-warning-outline color-orange"></i>
                            </span>
                        </el-tooltip>
                        在仓总数
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.SpaceInvens }}</span>
                    </template>
                </el-table-column>
                <el-table-column width="60" show-overflow-tooltip prop="UpLimit" label="上限"></el-table-column>
                <el-table-column width="60" show-overflow-tooltip prop="LowerLimit" label="下限"></el-table-column>
                <el-table-column width="80" show-overflow-tooltip prop="FloatRange" label="调整幅度"></el-table-column>
                <el-table-column width="80" show-overflow-tooltip label="自动浮动">
                    <template slot-scope="scope">
                        <i class="c-active" v-if="scope.row.IsAutoFloat">开启</i>
                        <i class="out-active" v-else>关闭</i>
                    </template>
                </el-table-column>
                <el-table-column width="80" show-overflow-tooltip prop="FloatUL" label="浮动上限"></el-table-column>
                <el-table-column width="80" show-overflow-tooltip prop="FloatLL" label="浮动下限"></el-table-column>
                <el-table-column width="145" show-overflow-tooltip prop="FloatWarningCount" label="触顶/底次数"></el-table-column>
                <el-table-column width="160" show-overflow-tooltip prop="WarningTime" label="警告时间"></el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button type="text" size="mini" @click="showSetDialog(scope.row)">设置上下限</el-button>
                            <el-button type="text" size="mini" style="color: red" @click="showSetIgnoreDialog(scope.row)">暂时忽略</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="库存商品搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-goods-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="90px">
                    <el-form-item label="汽配编码">
                        <el-autocomplete
                            ref="search_1"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCode"
                            :fetch-suggestions="searchAPCode"
                            :debounce="500"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchAPCodeLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-autocomplete
                            ref="search_2"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            :fetch-suggestions="searchGoodName"
                            :debounce="500"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchGoodNameLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-autocomplete
                            ref="search_3"
                            size="small"
                            style="width: 100%"
                            :debounce="500"
                            v-model="searchData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchAutoSeriseLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="在仓数">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_4"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent1"
                                @focus="selectAutoHandle('search_4')"
                            ></el-input>
                            <el-input
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent2"
                                v-if="searchData.Symbol == 'between'"
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="上限">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol1" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_5"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent3"
                                @focus="selectAutoHandle('search_5')"
                            ></el-input>
                            <el-input
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent4"
                                v-if="searchData.Symbol1 == 'between'"
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="下限">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol2" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_6"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent5"
                                @focus="selectAutoHandle('search_6')"
                            ></el-input>
                            <el-input
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent6"
                                v-if="searchData.Symbol2 == 'between'"
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="品牌">
                        <el-select
                            ref="search_7"
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="分类">
                        <el-select
                            ref="search_8"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList1" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产地">
                        <el-autocomplete
                            ref="search_9"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Origin"
                            :fetch-suggestions="searchOrigin"
                            :debounce="500"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchOriginLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="自动浮动">
                        <el-radio-group v-model="searchData.IsAutoFloat">
                            <el-radio :label="0">全部</el-radio>
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="2">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                </div>
            </div>
        </el-dialog>
        <!--    查看库存    -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :edit="false" :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="goodsId" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="批量修改" :visible.sync="isShowUpdate" width="450px" append-to-body :modal="false">
            <div class="dialog-content" v-if="isShowUpdate">
                <div class="flex" style="margin-bottom: 10px">
                    <div class="e-item1">
                        <div>修改项</div>
                        <div>
                            <el-select
                                @change="bacthSelect($event)"
                                size="small"
                                class="search-item"
                                style="width: 110px"
                                v-model="bacthUpdateData.UpdateKey"
                                clearable
                                placeholder="修改属性"
                            >
                                <el-option key="上限" label="上限" value="1"></el-option>
                                <el-option key="下限" label="下限" value="2"></el-option>
                                <el-option key="增减幅度" label="增减幅度" value="3"></el-option>
                                <el-option key="自动浮动" label="自动浮动" value="4"></el-option>
                                <el-option key="重置浮动" label="重置浮动" value="5"></el-option>
                                <el-option key="忽略设置" label="忽略设置" value="6"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="e-item2">
                        <div>结果值</div>
                        <div>
                            <el-input-number
                                v-if="bacthUpdateData.UpdateKey != '4' && bacthUpdateData.UpdateKey != '5' && bacthUpdateData.UpdateKey != '6'"
                                style="width: 260px"
                                size="small"
                                v-model.trim="bacthUpdateData.UpdateValue"
                                v-filter-special-char="bacthUpdateData.UpdateValue"
                                placeholder="输入修改后的结果值"
                                controls-position="right"
                                :min="0"
                                :precision="0"
                            ></el-input-number>
                            <el-switch
                                @change="changeSwitch()"
                                v-else-if="bacthUpdateData.UpdateKey == '4'"
                                active-text="开启"
                                inactive-text="关闭"
                                style="width: 100%"
                                v-model="bacthUpdateData.UpdateValue"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                            ></el-switch>
                            <el-switch
                                @change="changeSwitch()"
                                v-else-if="bacthUpdateData.UpdateKey == '5'"
                                active-text="是"
                                inactive-text="否"
                                style="width: 100%"
                                v-model="bacthUpdateData.UpdateValue"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                            ></el-switch>
                            <el-select 
                                v-model="bacthUpdateData.UpdateValue"
                                v-else-if="bacthUpdateData.UpdateKey == '6'"
                                style="width: 100%"
                                size="small"
                                filterable remote>
                                <el-option label="忽略3天" :value="0"></el-option>
                                <el-option label="永久忽略" :value="1"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="dialog-footer" style="text-align: right">
                    <el-button size="small" @click="closeUpdateDialog">取消</el-button>
                    <el-button class="btn-primary" size="small" @click="confirmUpdate">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="isShowSet" width="350px" append-to-body :modal="false">
            <div class="dialog-content" v-if="isShowSet">
                <el-form ref="form" label-position="left" label-width="90px">
                    <el-form-item label="库存上限">
                        <el-input-number style="width: 100%" size="small" v-model="setData.UpLimit" :min="0" :step="1"></el-input-number>
                    </el-form-item>
                    <el-form-item label="库存下限">
                        <el-input-number style="width: 100%" size="small" v-model="setData.LowerLimit" :min="0" :step="1"></el-input-number>
                    </el-form-item>
                    <el-form-item label="调整幅度">
                        <el-input-number style="width: 100%" size="small" v-model="setData.FloatRange" :min="1" :step="1"></el-input-number>
                    </el-form-item>
                    <el-form-item label="自动浮动">
                        <el-switch
                            @change="changeSwitch()"
                            active-text="开启"
                            inactive-text="关闭"
                            style="width: 100%"
                            v-model="setData.IsAutoFloat"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                        ></el-switch>
                    </el-form-item>
                    <el-form-item label="重置浮动">
                        <el-switch
                            @change="changeSwitch()"
                            active-text="是"
                            inactive-text="否"
                            style="width: 100%"
                            v-model="setData.IsInitFloat"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                        ></el-switch>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer" style="text-align: right">
                    <el-button size="small" @click="closeSetDialog">取消</el-button>
                    <el-button class="btn-primary" size="small" @click="confirmSetData">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="dialogTitle2" :visible.sync="isShowSet2" width="350px" append-to-body :modal="false">
            <div class="dialog-content" v-if="isShowSet2">
                <el-form ref="form" label-position="left" label-width="90px">
                    <el-form-item label="忽略类型">
                        <el-select v-model="ignoreType" style="width: 100%" size="small" filterable remote>
                            <el-option label="忽略3天" :value="0"></el-option>
                            <el-option label="永久忽略" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer" style="text-align: right">
                    <el-button size="small" @click="closeSetDialog">取消</el-button>
                    <el-button class="btn-primary" size="small" @click="confirmIgnoreSet">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 近三个月销售数据 -->
        <el-dialog
            :close-on-click-modal="false"
            :title="salesDataTitle"
            width="600px"
            :visible.sync="salesDataVisible"
            v-dialog-drag
            append-to-body
            lock-scroll
            :modal="false"
            id="ap-image-dialog"
            custom-class="image-item-dialog"
        >
            <div style="padding-top: 5px; padding-bottom: 10px" v-if="salesDataVisible">
                <ux-grid :data="salesDataList" border style="width: 100%" ref="salesDataTable">
                    <ux-table-column resizable :title="item" min-width="100px" v-for="(item, index) in salesDataHeader" :key="index">
                        <template slot-scope="scope">
                            <template v-for="(item2, index2) in scope.row.list">
                                <span v-if="index == index2" :key="index2">
                                    {{ item2.Count }}
                                </span>
                            </template>
                        </template>
                    </ux-table-column>
                </ux-grid>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        APMsg,
        breadcrumb,
        elTableColumn
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    if (this.$refs.search_1) {
                        this.$refs.search_1.focus();
                        this.searchIndex = 1;
                    }
                });
            }
        },
        'bacthUpdateData.UpdateKey'() {
            this.bacthUpdateData.UpdateValue = '';
        }
    },
    data() {
        return {
            salesDataVisible: false,
            salesDataTitle: '',
            salesDataList: [],
            salesDataHeader: [],
            warehouseList: [],
            loading: false,
            optionLoading: false,
            isStopReq: false,
            isStopChildReq: false,
            isStartSearch: false,
            searchIndex: 1,
            goodsMsg: {},
            multipleSelection: [],
            goodsId: '',
            brand: [],
            choosedGood: {},
            typeList1: [],
            APMsgVisible: false, //编辑
            searchData: {
                WHId: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Symbol1: '',
                Invent3: 0,
                Invent4: 0,
                Symbol2: '',
                Invent5: 0,
                Invent6: 0,
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                SortProp: '',
                SortType: '',
                page: 1,
                limit: this.commonPageSize,
                SearchType: 2,
                Origin: '',
                IsAutoFloat: 0
            },
            setData: {
                WHId: '',
                GoodsId: '',
                UpLimit: 0,
                LowerLimit: 0,
                FloatRange: 0,
                IsAutoFloat: true,
                IsInitFloat: false
            },
            dialogTitle: '上下限设置', //dialog标题
            dialogTitle2: '忽略商品设置', //dialog标题
            dialogVisible: false,
            searchSetVisible: false,
            tableData: [],
            tableDataLength: 0,
            goodNameOptions: [],
            autoSeriseOptions: [],
            canSearch: true,
            showViewer: false,
            isShowSet: false,
            isShowSet2: false,
            ignoreType:0,
            isShowUpdate: false,
            bacthUpdateData: {
                UpdateKey: '',
                UpdateValue: '',
                SearchData: {},
                GoodsIds: []
            },
            apCategoryList: [],
            cateForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            originOptions: [],
            originForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            apCodeOptions: [],
            apCodeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            zeroPeriod: 0
            // spaceInvensCount:0,
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        this.getWarehouse();
        this.getConfigByCodes();
    },
    directives: {
        //用户选择栏的懒加载
        scrollLoad: {
            bind(el, binding, vnode) {
                //防抖函数
                function debounce(func, wait, immediate) {
                    //func函数，wait为时间周期
                    var timeout;
                    return function () {
                        var context = this,
                            args = arguments;
                        var later = function () {
                            timeout = null;
                            if (!immediate) {
                                func.apply(context, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            func.apply(context, args);
                        }
                    };
                }
                let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap');
                let listDom = el.querySelector('.el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list');
                //将滚动事件通过参数传入防抖函数中
                var myEfficientFn = debounce(function () {
                    let condition = wrapDom.offsetHeight + wrapDom.scrollTop + 10 - listDom.offsetHeight;
                    if (condition > 0 && !vnode.context.loading) {
                        //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
                        binding.value();
                    }
                }, 250);
                wrapDom.addEventListener('scroll', myEfficientFn, false); //绑定滚动事件
            }
        }
    },
    methods: {
        getConfigByCodes() {
            let that = this;
            let codes = ['spzcrqwsss'];
            that.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        let rValue = data[i].RValue;
                        switch (code) {
                            case 'spzcrqwsss':
                                if (result) that.zeroPeriod = rValue;
                                break;
                        }
                    }
                }
            });
        },
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            //按下一页、上一页、重新查询的时候，停下子接口的查询
            if (key === 113) {
                e.preventDefault();
                that.dialogVisible = true;
                that.isStartSearch = true;
            }
            if (key === 13) {
                //批量修改时取消回车事件
                if (!that.isShowUpdate) {
                    e.preventDefault();
                    if (
                        (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                        (!that.$refs.search_8 || !that.$refs.search_8.visible) &&
                        (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                        (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                        (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible) &&
                        that.canSearch
                    ) {
                        that.handleSearch();
                    }
                    that.canSearch = true;
                    that.isStartSearch = false;
                }
            }
            //ESC
            if (key === 27) {
                that.canSearch = true;
                that.showViewer = false;
                that.salesDataVisible = false;
                if (
                    (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) ||
                    (that.$refs.search_3 && that.$refs.search_3.suggestionVisible) ||
                    (that.$refs.search_1 && that.$refs.search_1.suggestionVisible)
                ) {
                    if (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) that.$refs.search_1.suggestions = [];
                    if (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) that.$refs.search_2.suggestions = [];
                    if (that.$refs.search_3.suggestionVisible) that.$refs.search_3.suggestions = [];
                    return;
                }
                e.preventDefault();
                if (that.dialogVisible) {
                    that.dialogVisible = false;
                    that.isStartSearch = false;
                }
            }
            //右键
            if (key === 39) {
                if (!this.dialogVisible && !that.showViewer) {
                    e.preventDefault();
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);

                    if (page < totalPages) {
                        that.isStopChildReq = true;
                        that.isStartSearch = false;
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                    return;
                }
            }
            //左键
            if (key === 37) {
                if (!that.dialogVisible && !that.showViewer) {
                    e.preventDefault();
                    if (that.searchData.page !== 1) {
                        that.isStopChildReq = true;
                        that.isStartSearch = false;
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                    return;
                }
            }
            //下键
            if (key == 40) {
                that.canSearch = true;
                e.preventDefault();
                if (!that.searchSetVisible && !that.APMsgVisible) {
                    if (that.dialogVisible) {
                        if (that.searchIndex != 10) {
                            if (
                                (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                                (!that.$refs.search_8 || !that.$refs.search_8.visible) &&
                                (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 7 || that.searchIndex == 8 || that.searchIndex == 9) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex += 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    }
                    return;
                }
            }
            //上键
            if (key == 38) {
                that.canSearch = true;
                e.preventDefault();
                if (!that.searchSetVisible && !that.APMsgVisible) {
                    if (that.dialogVisible) {
                        if (that.searchIndex != 1) {
                            if (
                                (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                                (!that.$refs.search_8 || !that.$refs.search_8.visible) &&
                                (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 7 || that.searchIndex == 8 || that.searchIndex == 9) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex -= 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    }
                    return;
                }
            }
        },
        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].GoodsId);
            }
            this.bacthUpdateData.GoodsIds = idList;
        },
        // 配件信息
        showAPMsgDialog(id) {
            this.goodsId = id;
            this.APMsgVisible = true;
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        searchGoodsBrand() {
            if (this.brand.length > 0) return;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .finally(() => {});
        },
        searchGoodsType() {
            if (this.typeList1.length > 0) return;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList1 = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.searchData.Symbol = '';
            this.searchData.Invent1 = 0;
            this.searchData.Invent2 = 0;
            this.searchData.Symbol1 = '';
            this.searchData.Invent3 = 0;
            this.searchData.Invent4 = 0;
            this.searchData.Symbol2 = '';
            this.searchData.Invent5 = 0;
            this.searchData.Invent6 = 0;
            this.searchData.AutoSerise = '';
            this.searchData.APCode = '';
            this.searchData.Origin = '';
            this.searchData.BrandName = [];
            this.searchData.GoodName = '';
            this.searchData.Cate = [];
            this.searchData.SortProp = '';
            this.searchData.SortType = '';
            this.searchData.page = 1;
            this.searchData.limit = this.commonPageSize;
            this.searchData.SearchType = 2;
            this.searchData.IsAutoFloat = 0;
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        // 获取数据
        getTableData() {
            if (!this.isStopReq) {
                if (this.searchData.Symbol) {
                    //''空值isNan 也是返会false 所以要加parseInt做强制转换
                    if (this.searchData.Symbol == 'between') {
                        if (isNaN(parseInt(this.searchData.Invent1))) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                        if (isNaN(parseInt(this.searchData.Invent2))) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                    } else {
                        if (isNaN(parseInt(this.searchData.Invent1))) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                    }
                } else {
                    this.searchData.Invent1 = 0;
                    this.searchData.Invent2 = 0;
                }
                this.loading = true;
                this.isStopReq = true;
                this.isStopChildReq = false;
                this.$util
                    .axiosPost({
                        url: '/api/EntpGoods/GetEntpPartListForLimitWarning',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        this.loading = false;
                        let data = res.data;
                        if (!data) {
                            this.tableData = [];
                            return;
                        }
                        let goodsIds = [];
                        for (let i = 0; i < data.length; i++) {
                            goodsIds.push(data[i].GoodsId);
                            data[i].AutoSeries = [];
                            data[i].LoadSpaceInvent = true;
                        }
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        gotolimitWarningSet(){

        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            this.$refs[ref].select();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.GoodsId) {
                this.showAPMsgDialog(event.GoodsId);
            }
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList1.length == 0) that.searchGoodsType();
            }
        },
        closeDialog(isEdit) {
            this.searchSetVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        },
        searchAPCode(key, cb) {
            if (![undefined].includes(key)) {
                this.apCodeForm.Page = 1;
                this.apCodeForm.stopLoad = false;
                this.apCodeForm.key = key;
                this.apCodeOptions = [];
            }
            let callback = cb;
            if (this.apCodeForm.stopLoad) return;
            this.$util.searchPartAttr(this.apCodeForm.key, 0, this.apCodeForm.Page, this.apCodeForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.apCodeForm.stopLoad = data.length < this.apCodeForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.apCodeOptions = [...this.apCodeOptions, ...arr];
                if (callback) {
                    callback(this.apCodeOptions);
                }
            });
        },
        searchAPCodeLoad() {
            this.apCodeForm.Page += 1;
            this.searchAPCode();
        },
        searchGoodName(key, cb) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            let callback = cb;
            if (this.goodNameForm.stopLoad) return;
            this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = [...this.goodNameOptions, ...arr];
                if (callback) {
                    callback(this.goodNameOptions);
                }
            });
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        searchAutoSerise(key, cb) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            let callback = cb;
            if (this.autoSeriseForm.stopLoad) return;
            this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...arr];
                if (callback) {
                    callback(this.autoSeriseOptions);
                }
            });
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        searchOrigin(key, cb) {
            if (![undefined].includes(key)) {
                this.originForm.Page = 1;
                this.originForm.stopLoad = false;
                this.originForm.key = key;
                this.originOptions = [];
            }
            let callback = cb;
            if (this.originForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.originForm.key, 3, this.originForm.Page, this.originForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.originForm.stopLoad = data.length < this.originForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.originOptions = [...this.originOptions, ...arr];
                if (callback) {
                    callback(this.originOptions);
                }
            });
        },
        searchOriginLoad() {
            this.originForm.Page += 1;
            this.searchOrigin();
        },
        stopSearch() {
            this.canSearch = false;
        },
        closeViewer() {
            this.showViewer = false;
        },
        bacthUpdate() {
            let that = this;
            if (that.bacthUpdateData.GoodsIds.length == 0) {
                that.$confirm('未选择批量更新的库存商品，是否将所有筛选结果进行更新？如果数据过多可能耗时稍长', '提醒', {
                    type: 'error',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        that.isShowUpdate = true;
                    })
                    .catch(() => {
                        return;
                    });
            } else that.isShowUpdate = true;
        },
        confirmUpdate() {
            let that = this;
            if (!that.bacthUpdateData.UpdateKey) {
                that.$util.warningMsg('请选择要修改项');
                return;
            }

            if (
                that.bacthUpdateData.UpdateValue === '' &&
                that.bacthUpdateData.UpdateValue < 0 &&
                that.bacthUpdateData.UpdateKey != 4 &&
                that.bacthUpdateData.UpdateKey != 5
            ) {
                that.$util.warningMsg('请填写结果值');
                return;
            }

            if (that.bacthUpdateData.UpdateValue === '' && (that.bacthUpdateData.UpdateKey == 4 || that.bacthUpdateData.UpdateKey == 5)) {
                that.bacthUpdateData.UpdateValue = true;
            }
            that.bacthUpdateData.SearchData = that.searchData;
            that.loading = true;
            that.$util
                .axiosPost({
                    url: '/api/EntpGoods/BacthUpdateLimitData',
                    data: that.bacthUpdateData,
                    hideLoading: true
                })
                .then(resp => {
                    if (resp.errcode == 0) {
                        that.$util.successMsg(resp.errmsg);
                        that.getTableData();
                        that.closeUpdateDialog();
                    }
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        confirmSetData() {
            let that = this;
            if (that.setData.UpLimit != 0 || that.setData.LowerLimit != 0) {
                if (that.setData.UpLimit <= that.setData.LowerLimit) {
                    that.$util.warningMsg('下限的值需要小于上限的值');
                    return;
                }
            }
            that.loading = true;
            that.$util
                .axiosPost({
                    url: '/api/EntpGoods/UpdateLimitData',
                    data: that.setData,
                    hideLoading: true
                })
                .then(resp => {
                    if (resp.errcode == 0) {
                        that.$util.successMsg('上下限修改成功');
                        that.getTableData();
                        that.closeSetDialog();
                    }
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        confirmIgnoreSet() {
            let that = this;
            that.loading = true;
            that.$confirm('将对商品' + that.dialogTitle2, '提醒', {
                type: 'error',
            })
                .then(() => {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpGoods/SetLimitIgnoreWarning',
                            data: {
                                GoodsId : that.setData.GoodsId,
                                WHId : that.setData.WHId,
                                Type : that.ignoreType
                            },
                            hideLoading: true
                        })
                        .then(resp => {
                            if (resp.errcode == 0) {
                                that.$util.successMsg('设置成功');
                                that.getTableData();
                            }
                        })
                        .finally(() => {
                            that.closeSetDialog();
                            that.loading = false;
                        });
                })
                .catch(() => {
                    return;
                }).finally(() => {
                    that.loading = false;
                });
        },
        closeUpdateDialog() {
            this.isShowUpdate = false;
            this.bacthUpdateData.GoodsIds = [];
            this.bacthUpdateData.UpdateKey = '';
            this.bacthUpdateData.UpdateValue = '';
            this.$refs.multipleTable.clearSelection();
        },
        //匹配品牌
        searchBrand(queryString, cb) {
            if (this.brandList && this.brandList.length > 0) {
                let list = this.brandList;
                this.querySearchAsync(list, queryString, cb);
            } else {
                this.getEnterprisePartBrandList(cb);
            }
        },
        //获取品牌分类
        getEnterprisePartBrandList(cb) {
            this.$util.searchGoodsBrand().then(res => {
                this.brandList = res;
                if (cb) {
                    cb(this.brandList);
                }
            });
        },
        querySearchAsync(list, queryString, cb) {
            let results = queryString ? list.filter(this.createStateFilter(queryString)) : list;
            cb(results);
        },
        createStateFilter(queryString) {
            return item => {
                if (item) {
                    let reg = new RegExp(queryString);
                    return reg.test(item.Text);
                }
            };
        },
        // 搜索汽配分类
        searchCate(key) {
            if (![undefined].includes(key)) {
                this.cateForm.Page = 1;
                this.cateForm.stopLoad = false;
                this.cateForm.key = key;
                this.apCategoryList = [];
            }
            if (this.cateForm.stopLoad) return;
            this.$util
                .getEntpApCategoryList(this.cateForm.key, this.cateForm.Page, this.cateForm.Limit)
                .then(data => {
                    if (!data) return;
                    this.cateForm.stopLoad = data.length < this.cateForm.Limit;
                    this.apCategoryList = [...this.apCategoryList, ...data];
                })
                .catch(() => {});
        },
        // 客户名称列表，加载更多
        searchCateLoad() {
            this.cateForm.Page += 1;
            this.searchCate();
        },
        cateVisibleChangecar(event) {
            let that = this;
            if (event) {
                if (that.apCategoryList.length == 0) that.searchCate('');
            } else {
                if (!that.bacthUpdateData.UpdateValue) {
                    that.bacthUpdateData.UpdateValue = that.cateForm.key;
                }
            }
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
                if (this.warehouseList && this.warehouseList[0]) {
                    this.searchData.WHId = this.warehouseList[0].WarehouseId;
                    this.$util.getSysConfig('splbycfpc').then(res => {
                        if (res.Result) {
                            this.searchData.SpaceType = ['0', '1'];
                        }
                        this.getTableData();
                    });
                }
            });
        },
        showSetDialog(item) {
            if (item) {
                this.setData.WHId = this.searchData.WHId;
                this.setData.GoodsId = item.GoodsId;
                this.setData.IsAutoFloat = item.IsAutoFloat;
                this.setData.UpLimit = item.UpLimit;
                this.setData.LowerLimit = item.LowerLimit;
                this.setData.FloatRange = item.FloatRange;
                this.isShowSet = true;
                this.dialogTitle = '【' + item.APCode + '】上下限设置';
            }
        },
        showSetIgnoreDialog(item) {
            if (item) {
                this.setData.WHId = this.searchData.WHId;
                this.setData.GoodsId = item.GoodsId;
                this.isShowSet2 = true;
                this.dialogTitle2 = '【' + item.APCode + '】忽略商品设置';
            }
        },
        closeSetDialog() {
            this.setData = {
                WHId: '',
                GoodsId: '',
                UpLimit: 0,
                LowerLimit: 0,
                FloatRange: 0
            };
            this.isShowSet = false;
            this.isShowSet2 = false;
            this.dialogTitle = '上下限设置';
            this.dialogTitle2 = '忽略商品设置';
        },
        showSaleData(event, column) {
            if (
                column.property == 'Inventory' ||
                column.property == 'SpaceInvens' ||
                column.property == 'UpLimit' ||
                column.property == 'LowerLimit' ||
                column.property == 'FloatRange' ||
                column.property == 'FloatUL' ||
                column.property == 'FloatLL'
            ) {
                if (event.GoodsId) {
                    this.getGoodsLatestOutRecord(event.GoodsId).then(data => {
                        if (data) {
                            this.salesDataTitle = `商品编码【${event.APCode}】`;
                            this.salesDataList = [{ list: data.list }];
                            this.salesDataHeader = data.header;
                            this.salesDataVisible = true;
                        }
                    });
                }
            }
        },
        getGoodsLatestOutRecord(id) {
            let that = this;
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpSaleOrder/GetLatelySalesOutData',
                        data: {
                            goodsId: id,
                            sId: that.searchData.WHId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        resolve(res.data);
                    });
            });
        },
        changeSwitch() {
            this.$forceUpdate();
        },
        bacthSelect(value) {
            if (value == 4 || value == 5) this.$forceUpdate();
        }
    }
};
</script>
<style lang="less" scoped>
#search-goods-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

.color-orange {
    color: orange;
}

.el-form-item {
    margin-bottom: 0;
}
</style>
<style lang="less">
.autocompleteInput .el-input input {
    width: 260px;
    height: 32px;
}

.e-item1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 30%;
}

.e-item2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70%;
}
.el-autocomplete-suggestion {
    width: 300px !important;
}
.search-quick {
    display: flex;
    flex-direction: row;
    margin-left: 20px;
    color: #636363;
}

.search-quick-btn {
    color: #e77878;
    font-weight: bold;
    width: 92px;
    cursor: pointer;
    font-size: 15px;
}
</style>
